export default {
  id: 117,
  name: 'blob #xxx - à fleur de conscience minor mix', 
  spheres: [
    {matcapTextureImg: 'assets/textures/spring-fever/minos/0046.png', perlin: {speed: 0.00027, k: 0.838, mul: 0.828}},
    {matcapTextureImg: 'assets/textures/spring-fever/minos/0046_minor_mix_trans.png', perlin: {speed: 0.00027, k: 0.938, mul: 0.828}},
    {matcapTextureImg: 'assets/textures/spring-fever/minos/0046_minor_nomix_trans_white.png', perlin: {speed: 0.00027, k: 0.838, mul: 1.11828}},
    {matcapTextureImg: 'assets/textures/spring-fever/minos/0046_minor_mix_trans.png', perlin: {speed: 0.00027, k: 1.738, mul: 1.228}},
    {matcapTextureImg: 'assets/textures/spring-fever/minos/0046_minor_nomix_trans.png', perlin: {speed: 0.00027, k: 2.738, mul: 1.828}},
  ]
}